import {Fragment} from 'react';

import BadgeCard from '@/components/BadgeCard/BadgeCard';
import type {PluralFormsModel} from '@/types/aem';
import type {Badge} from '@/types/loyalty';
import {twx} from '@/utils/tailwindUtils';

type BadgesGridProps = {
    badges: Badge[];
    className?: string;
    showProgress?: boolean;
    actionsRemainingPluralForms?: PluralFormsModel;
    onBadgeClick?: (badge: Badge) => void;
    renderCard?: (badge: Badge) => React.ReactNode;
};

const BadgesGrid = ({
    badges,
    className,
    showProgress = false,
    actionsRemainingPluralForms,
    onBadgeClick,
    renderCard,
}: BadgesGridProps) => {
    if (!badges.length) return null;

    return (
        <div className={twx('grid grid-cols-2 gap-2', className)}>
            {badges.map((badge, index) =>
                renderCard ? (
                    <Fragment key={`${badge.id}-${index}`}>{renderCard(badge)}</Fragment>
                ) : (
                    <BadgeCard
                        key={`${badge.id}-${index}`}
                        badge={badge}
                        showProgress={showProgress}
                        actionsRemainingPluralForms={actionsRemainingPluralForms}
                        onClick={onBadgeClick ? () => onBadgeClick(badge) : undefined}
                    />
                )
            )}
        </div>
    );
};

export default BadgesGrid;
